export const facturacionRoutes = [
  {
    path: '/facturacion',
    name: 'Facturacion Masiva',
    component: () =>
      import(
        /* webpackChunkName: "financiera" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiInvoiceTextArrowRightOutline',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Facturación masiva',
      requiresSession: true,
      perfiles: ['FACTURACION'],
      permiso: []
    },
    children: [
      {
        path: '/facturacion/facturas',
        name: 'FacturacionFacturas',
        component: () =>
          import(
            /* webpackChunkName: "facturacion" */ '@/modules/Facturacion/views/DocumentosIndex.vue'
          ),
        props: { tipo: 'INVOICE' },
        icon: 'mdiInvoiceTextOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Facturas',
          requiresSession: true,
          permiso: [],
          perfiles: ['FACTURACION'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/facturacion/notas-credito',
        name: 'FacturacionNotasCredito',
        component: () =>
          import(
            /* webpackChunkName: "facturacion" */ '@/modules/Facturacion/views/DocumentosIndex.vue'
          ),
        props: { tipo: 'NOTA' },
        icon: 'mdiFileDocumentMinusOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Notas Crédito',
          requiresSession: true,
          permiso: [],
          perfiles: ['FACTURACION'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/facturacion/consultas',
        name: 'FacturacionConsultas',
        component: () =>
          import(
            /* webpackChunkName: "facturacion" */ '@/modules/Facturacion/views/ConsultasIndex.vue'
          ),
        icon: 'mdiMagnify',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Consultas',
          requiresSession: true,
          permiso: [],
          perfiles: ['FACTURACION'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/facturacion/logs',
        name: 'FacturacionLogs',
        component: () =>
          import(
            /* webpackChunkName: "facturacion" */ '@/modules/Facturacion/views/LogsIndex.vue'
          ),
        icon: 'mdiTextBoxSearchOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Logs',
          requiresSession: true,
          permiso: [],
          perfiles: ['FACTURACION'],
          showBackButton: false
        },
        children: []
      }
    ]
  }
]
